import { Cpu } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

export const TechInfo = ({ version, testId = "tech-info" }) => {
  const { t } = useI18n();
  if (version.tech_status === "pending") return <p className="text-xs text-neutral-400" data-testid={`${testId}-pending`}>{t("tech.pending")}</p>;
  if (version.tech_status !== "ok" || !version.manifest) {
    return <p className="text-xs font-semibold text-red-300" data-testid={`${testId}-unavailable`}>{t("tech.unavailable")}</p>;
  }
  const m = version.manifest;
  const rows = [
    ["tech.label", m.label],
    ["tech.package", m.package],
    ["tech.versionName", m.version_name],
    ["tech.minSdk", m.min_sdk ? `API ${m.min_sdk}${m.min_android ? ` (Android ${m.min_android})` : ""}` : "—"],
    ["tech.permissions", m.permissions?.length ? m.permissions.map((p) => p.replace("android.permission.", "")).join(", ") : t("tech.none")],
    ["tech.features", m.features?.length ? m.features.map((f) => f.replace("android.hardware.", "")).join(", ") : t("tech.none")],
  ];
  return (
    <div className="rounded-xl border border-[rgba(245,197,66,0.18)] bg-black/30 p-3" data-testid={testId}>
      <p className="mb-2 flex items-center gap-1.5 text-[0.7rem] font-bold uppercase tracking-wider text-[var(--gold)]"><Cpu className="h-3.5 w-3.5" /> {t("tech.title")}</p>
      <dl className="grid gap-1 text-xs sm:grid-cols-[150px_minmax(0,1fr)]">
        {rows.map(([k, v]) => (
          <div key={k} className="contents">
            <dt className="text-neutral-500">{t(k)}</dt>
            <dd className="break-words text-neutral-200 [overflow-wrap:anywhere]" data-testid={`${testId}-${k.split(".")[1]}`}>{v || "—"}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
};
